import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'
import PassportLayout from '../views/layout/Passport'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  {
    path: '/passport',
    component: PassportLayout,
    hidden: true,
    children: [
      { path: '/login', name: 'login', component: resolve => require(['@/views/passport/login'], resolve), hidden: true },
      { path: '/forgot-password', name: 'forgot-password', component: resolve => require(['@/views/passport/forgot-password'], resolve), hidden: true }
    ]
  },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '/my-account',
    component: Layout,
    hidden: true,
    children: [{
      path: '/my-account',
      name: 'myccount',
      component: () => import('@/views/account/index'),
      meta: { title: '我的帐号' }
    }]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      name: 'dashboard',
      component: resolve => require(['@/views/dashboard/index'], resolve),
      meta: { title: '首页', icon: 'dashboard', keepAlive: true }
    }]
  },
  {
    path: '/gift',
    component: Layout,
    name: 'Gift',
    meta: { title: '礼品管理', icon: 'gift' },
    children: [
      {
        path: 'detail/:id',
        name: 'GiftDetail',
        component: resolve => require(['@/views/gift/detail'], resolve),
        meta: { title: '礼品详情' },
        hidden: true
      },
      {
        path: 'create-select-type',
        name: 'GiftCreateTypeSelector',
        component: resolve => require(['@/views/gift/type-selector'], resolve),
        meta: { title: '创建礼品' }
      },
      {
        path: 'create',
        name: 'GiftCreate',
        component: resolve => require(['@/views/gift/create'], resolve),
        meta: { title: '创建礼品' },
        hidden: true
      },
      {
        path: 'modify/:id',
        name: 'GiftModify',
        component: resolve => require(['@/views/gift/edit'], resolve),
        meta: { title: '修改礼品信息' },
        hidden: true
      },
      {
        path: 'list',
        name: 'GiftList',
        component: resolve => require(['@/views/gift/list'], resolve),
        meta: { title: '礼品列表', keepAlive: true }
      },
      {
        path: 'settings',
        name: 'GiftSettings',
        component: resolve => require(['@/views/gift/settings'], resolve),
        meta: { title: '礼品设置' }
      }
    ]
  },
  {
    path: '/activity',
    component: Layout,
    name: 'Activity',
    meta: { title: '扫码活动', icon: 'ercode' },
    children: [
      {
        path: 'create-select-type',
        name: 'ActivityCreateForTypeSelector',
        component: resolve => require(['@/views/activity/create-for-type'], resolve),
        meta: { title: '创建活动' }
      },
      {
        path: 'create',
        name: 'ActivityCreate',
        component: resolve => require(['@/views/activity/create'], resolve),
        meta: { title: '创建活动' },
        hidden: true
      },
      {
        path: 'list',
        name: 'ActivityList',
        component: resolve => require(['@/views/activity/list'], resolve),
        meta: { title: '活动列表', keepAlive: true }
      },
      {
        path: 'detail/:id',
        name: 'ActivityDetail',
        component: resolve => require(['@/views/activity/detail'], resolve),
        meta: { title: '活动详情' },
        hidden: true
      },
      {
        path: 'qrcode',
        name: 'ActivityQrcode',
        component: resolve => require(['@/views/activity/qrcode'], resolve),
        meta: { title: '二维码管理' }
      },
      {
        path: 'award-records',
        name: 'ActivityAwardRecords',
        component: resolve => require(['@/views/activity/award-records'], resolve),
        meta: { title: '活动兑奖记录', keepAlive: true }
      },
      {
        path: 'award-records/:id',
        name: 'ActivityAwardRecordDetail',
        component: resolve => require(['@/views/activity/award-records/Detail'], resolve),
        meta: { title: '活动兑奖详情' },
        hidden: true
      }
    ]
  },
  {
    path: '/beyond-goods',
    component: Layout,
    name: 'BeyondGoods',
    meta: { title: '窜货管理', icon: 'batch' },
    children: [
      {
        path: 'create',
        name: 'BeyondGoodsCreate',
        component: resolve => require(['@/views/beyond-goods/activity-create'], resolve),
        meta: { title: '新建防窜货活动' }
      },
      {
        path: '/list',
        name: 'BeyondGoodsList',
        component: resolve => require(['@/views/beyond-goods/activity-list'], resolve),
        meta: { title: '防窜货活动列表' }
      },
      {
        path: ':id/modify',
        name: 'BeyondGoodsModify',
        component: resolve => require(['@/views/beyond-goods/activity-modify'], resolve),
        meta: { title: '防窜货活动修改' },
        hidden: true
      },
      {
        path: '/beyond-goods/qrcode',
        name: 'BeyondGoodsActivityQrcodes',
        component: resolve => require(['@/views/beyond-goods/qrcode'], resolve),
        meta: { title: '二维码管理' }
      },
      {
        path: '/notice/list',
        name: 'BeyondGoodsActivityList',
        component: resolve => require(['@/views/beyond-goods/activity-notice-list'], resolve),
        meta: { title: '窜货预警通知' }
      },
      {
        path: '/notice/:id/detail',
        name: 'BeyondGoodsActivityDetail',
        component: resolve => require(['@/views/beyond-goods/activity-notice-detail'], resolve),
        meta: { title: '窜货预警通知详情' },
        hidden: true
      }
    ]
  },
  {
    path: '/guide',
    component: Layout,
    name: 'Guide',
    meta: { title: '导购管理', icon: 'shopping' },
    children: [
      {
        path: 'orders',
        name: 'GuideOrders',
        component: resolve => require(['@/views/guide/rebates'], resolve),
        meta: { title: '返利记录', keepAlive: true }
      },
      {
        path: 'members',
        name: 'GuideMemberList',
        component: resolve => require(['@/views/guide/members'], resolve),
        meta: { title: '导购员列表', keepAlive: true }
      },
      {
        path: 'detail/:id',
        name: 'GuideMemberDetail',
        component: resolve => require(['@/views/guide/member/detail'], resolve),
        meta: { title: '导购员详情' },
        hidden: true
      },
      {
        path: 'review',
        name: 'GuideReview',
        component: resolve => require(['@/views/guide/review'], resolve),
        meta: { title: '导购员审核' }
      },
      {
        path: 'settings',
        name: 'GuideSettings',
        component: resolve => require(['@/views/guide/settings'], resolve),
        meta: { title: '导购设置' }
      },
      {
        path: 'stores',
        name: 'Store',
        component: resolve => require(['@/views/guide/stores'], resolve),
        meta: { title: '门店渠道设置' }
      }
    ]
  },
  {
    path: '/integral-mall',
    component: Layout,
    name: 'IntegralMall',
    meta: { title: '积分商城', icon: 'jifen' },
    children: [
      {
        path: 'orders',
        name: 'IntegralMallOrders',
        component: resolve => require(['@/views/integral-mall/orders'], resolve),
        meta: { title: '商城订单', keepAlive: true }
      },
      {
        path: 'orders/:id',
        name: 'IntegralMallOrderDetail',
        component: resolve => require(['@/views/integral-mall/orders/detail'], resolve),
        meta: { title: '商城订单详情' },
        hidden: true
      },
      {
        path: 'settings',
        name: 'IntegralMallSettings',
        component: resolve => require(['@/views/integral-mall/settings'], resolve),
        meta: { title: '商城设置' }
      }
    ]
  },
  {
    path: '/member',
    component: Layout,
    name: 'Member',
    meta: { title: '会员管理', icon: 'member' },
    children: [
      {
        path: 'list',
        name: 'MemberList',
        component: resolve => require(['@/views/member/list'], resolve),
        meta: { title: '会员列表', keepAlive: true }
      },
      {
        path: 'review',
        name: 'MemberReview',
        component: resolve => require(['@/views/member/review'], resolve),
        meta: { title: '会员审核' }
      },
      {
        path: 'settings',
        name: 'MemberSettings',
        component: resolve => require(['@/views/member/settings'], resolve),
        meta: { title: '会员设置' }
      },
      {
        path: 'blacklist',
        name: 'MemberBlacklist',
        component: resolve => require(['@/views/member/blacklist'], resolve),
        meta: { title: '黑名单', keepAlive: true }
      }
    ]
  },
  {
    path: '/reports',
    component: Layout,
    name: 'Reports',
    meta: { title: '大数据报表', icon: 'report' },
    children: [
      {
        path: 'goods-heat-map',
        name: 'ReportHeatMap',
        component: resolve => require(['@/views/reports/goods-heat-map'], resolve),
        meta: { title: '销售热图', keepAlive: true }
      },
      {
        path: 'goods-heat-map2',
        name: 'ReportHeatMap2',
        component: resolve => require(['@/views/reports/goods-heat-map2'], resolve),
        meta: { title: '窜货热图', keepAlive: true, isBeyond: true }
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    name: 'System',
    meta: { title: '系统设置', icon: 'system' },
    children: [
      {
        path: 'setting',
        name: 'SystemSetting',
        component: resolve => require(['@/views/system/setting'], resolve),
        meta: { title: '基本设置', keepAlive: true }
      },
      {
        path: 'official-account',
        name: 'SystemOfficialAccount',
        component: resolve => require(['@/views/system/official-account'], resolve),
        meta: { title: '公众号设置' }
      }
    ]
  },

  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
